<template>
  <div class="inventory-box">
    <div class="inventory-header">
      <div class="inventory-header-left" v-loading="loading">
        <div class="inventory-header-left-title">注册分类</div>
        <div class="inventory-header-left-chart">
          <div class="header-left-chart">
            <div
              ref="inventoryPieRef"
              style="height: 180px"
              @click="handleClick"
            />
          </div>
          <div class="header-left-chart-text">
            <div class="chart-text-item" style="width: 40%">
              <div class="text-item-name">注册分类</div>
              <div
                v-for="(v, i) in pagePieInfo.circleData"
                :key="i"
                class="text-item-value"
              >
                <div
                  class="text-item-value-icon"
                  :style="`background:${color[i]}`"
                />
                <div class="text-item-value-title">{{ v.name }}</div>
              </div>
            </div>
            <div class="chart-text-item" style="width: 30%">
              <div class="text-item-name">存量</div>
              <div
                v-for="(v, i) in pagePieInfo.circleData"
                :key="i"
                class="text-item-value"
              >
                {{ v.count }}
              </div>
            </div>
            <div class="chart-text-item" style="width: 30%">
              <div class="text-item-name">占比</div>
              <div
                v-for="(v, i) in pagePieInfo.circleData"
                :key="i"
                class="text-item-value"
              >
                {{ v.percent }}%
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inventory-header-right">
        <div class="inventory-header-right-item">
          <div class="header-right-item">
            <div class="header-right-item-label">注册分类</div>
            <div class="header-right-item-value">
              <el-select
                v-model="queryParam.registDrugType"
                multiple
                collapse-tags
                placeholder="请选择"
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.drugRegistTypes"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">药品标识</div>
            <div class="header-right-item-value">
              <el-select
                v-model="queryParam.specialType"
                multiple
                collapse-tags
                placeholder="请选择"
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.ownSpecialDrugTypes"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">库存情况</div>
            <div class="header-right-item-value">
              <el-select
                v-model="queryParam.storageState"
                placeholder="请选择"
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.stockStatus"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
        </div>
        <div class="inventory-header-right-item">
          <div class="header-right-item">
            <div class="header-right-item-label">药品通用名</div>
            <div class="header-right-item-value">
              <el-input
                v-model="queryParam.commonName"
                placeholder="请输入"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">货主机构</div>
            <div class="header-right-item-value">
              <el-select
                v-model="queryParam.ownEnterprise"
                placeholder="请选择"
                size="mini"
                style="width: 100%"
              >
                <el-option
                  v-for="item in filterData.ownEnterprises"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">上市持有人</div>
            <div class="header-right-item-value">
              <el-input
                v-model="queryParam.quotedHolder"
                placeholder="请输入"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
        </div>
        <div class="inventory-header-right-item">
          <div class="header-right-item">
            <div class="header-right-item-label">生产企业</div>
            <div class="header-right-item-value">
              <el-input
                v-model="queryParam.produceEnterprise"
                placeholder="请输入"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">批准文号</div>
            <div class="header-right-item-value">
              <el-input
                v-model="queryParam.approvalNo"
                placeholder="请输入"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">生产批号</div>
            <div class="header-right-item-value">
              <el-input
                v-model="queryParam.batchNo"
                placeholder="请输入"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
        </div>
        <div class="inventory-header-right-item">
          <div class="header-right-item">
            <div class="header-right-item-label">是否临期</div>
            <div class="header-right-item-value">
              <el-select
                v-model="queryParam.inventoryDay"
                placeholder="请选择"
                size="mini"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in filterData.inventoryDay"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="header-right-item">
            <div class="header-right-item-label">药品商品名</div>
            <div class="header-right-item-value">
              <el-input
                v-model="queryParam.commodityName"
                placeholder="请输入"
                size="mini"
                @keyup.enter.native="handleSearch"
              />
            </div>
          </div>
        </div>
        <div class="inventory-header-right-button">
          <el-button type="primary" size="mini" @click="handleSearch"
            >查询</el-button
          >
          <el-button plain size="mini" @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>
    <div class="table-box">
      <div class="table-d">
        <el-table
          ref="workTableRef"
          :data="tableList"
          stripe
          :header-cell-style="{
            background: '#F0F3F7',
            color: '#2a354e',
            fontWeight: 400,
          }"
          height="440"
          highlight-current-row
          :row-key="'id'"
          @row-click="handleRowClick"
          @sort-change="handleSortChange"
          v-loading="loading"
          size="mini"
        >
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <span
                style="color: #4076f2; cursor: pointer"
                @click="handleTableDetail(scope.row)"
                >查看详情</span
              >
            </template>
          </el-table-column>

          <el-table-column prop="commonName" label="药品通用名" width="250" />
          <el-table-column
            prop="commodityName"
            label="药品商品名"
            width="250"
          />
          <el-table-column
            prop="dosageForm"
            label="剂型"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="drugSpecification"
            label="制剂规格"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="quantity"
            label="库存"
            width="150"
            :show-overflow-tooltip="true"
            sortable="custom"
          />
          <el-table-column
            prop="inventoryDay"
            label="库存天数"
            width="150"
            :show-overflow-tooltip="true"
            sortable="custom"
          />
          <el-table-column
            prop="expiredDayStr"
            label="是否临期"
            width="150"
            :show-overflow-tooltip="true"
            sortable="custom"
          />
          <el-table-column prop="enterpriseName" label="货主机构" width="250" />
          <el-table-column prop="quotedHolder" label="上市持有人" width="250" />
          <el-table-column
            prop="approvalNo"
            label="批准文号"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="produtionEnterpriseName"
            label="生产企业"
            width="250"
          />
          <el-table-column
            prop="insuranceDrugCatalog"
            label="药理分类"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="drugCode"
            label="医保药品编码"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="drugRegistType"
            label="注册分类"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="specialType"
            label="	药品标识"
            min-width="150"
            :show-overflow-tooltip="true"
          />
        </el-table>
      </div>
      <div class="table-page">
        <div class="table-page-index">当前 {{ paging.index }} 页</div>
        <el-pagination
          :current-page="paging.index"
          :page-size="paging.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <Code ref="codeRef" />
  </div>
</template>

<script>
import Code from "@/components/CodeList";

export default {
  name: "Page",
  components: { Code },
  props: {
    pagePieInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      color: ["#1BC88E", "#4076F2", "#FF1616", "#D2D2D2"],
      queryParam: {
        barcode: "",
        registDrugType: [],
        ownEnterprise: "",
        specialType: [],
        quotedHolder: "",
        produceEnterprise: "",
        approvalNo: "",
        commonName: "",
        commodityName: "",
        batchNo: "",
        storageState: "1",
        inventoryDay: "",
        orders: {
          quantity: null,
          inventoryDay: null,
          expiredDate: null,
        },
      },
      filterData: {
        drugRegistTypes: [],
        ownEnterprises: [],
        ownSpecialDrugTypes: [],
        stockStatus: [],
      },
      paging: {
        index: 1,
        size: 100,
      },
      total: 0,
      tableList: [],
      selectedRow: null,
      loading: false,
    };
  },
  methods: {
    handleClick() {
      console.log(123);
    },
    handleRowClick(row) {
      this.selectedRow = row;
    },
    handleSortChange(value) {
      // 实时库存
      if (value.prop === "quantity") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.quantity = true;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.quantity = false;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.expiredDate = null;
        }
      }
      // 库存天数
      if (value.prop === "inventoryDay") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.inventoryDay = true;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.inventoryDay = false;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.expiredDate = null;
        }
      }
      // 失效日期
      if (value.prop === "expiredDayStr") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
          this.queryParam.orders.expiredDate = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.expiredDate = true;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.expiredDate = false;
          this.queryParam.orders.quantity = null;
          this.queryParam.orders.inventoryDay = null;
        }
      }
      this.paging.index = 1;
      this.getTableList();
    },
    isPositiveNumber(value) {
      const num = Number(value);
      return !isNaN(num) && isFinite(value);
    },
    handleReset() {
      this.queryParam = {
        barcode: "",
        registDrugType: [],
        ownEnterprise: "",
        specialType: [],
        quotedHolder: "",
        produceEnterprise: "",
        approvalNo: "",
        commonName: "",
        commodityName: "",
        batchNo: "",
        storageState: "1",
        inventoryDay: "",
      };
    },
    handleSearch() {
      this.paging.index = 1;
      this.getTableList();
    },
    handleTableCode(value) {
      this.$refs.codeRef.show({
        standardCode: value.standardCode,
      });
    },
    handleSizeChange(value) {
      this.paging.index = 1;
      this.paging.size = value;
      this.getTableList();
    },
    handleCurrentChange(value) {
      this.paging.index = value;
      this.getTableList();
    },
    handleTableDetail(value) {
      this.$emit("pageTableDetail", value);
    },
    async getTableList() {
      this.loading = true;
      const { data, extended } = await this.$api.stock.GetStockList({
        ...this.queryParam,
        paging: this.paging,
      });
      this.tableList = data;
      this.total = extended.paging.total;
      this.loading = false;
    },
    async pageFetchData() {
      this.loading = true;
      const { data } = await this.$api.stock.GetFilters();
      this.filterData = data;
      const { data: tableData, extended } = await this.$api.stock.GetStockList({
        ...this.queryParam,
        paging: this.paging,
      });
      this.tableList = tableData;
      this.total = extended.paging.total;
      const { data: pagePieData } = await this.$api.stock.GetCircle();
      this.loading = false;
      return pagePieData;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./page.scss";
</style>
